"use client";

import { AdapterNotDetectedWallet, AdapterWallet } from "@aptos-labs/wallet-adapter-react";
import { useCallback } from "react";
import { stack } from "styled-system/patterns";

import { SupportedNetworkId } from "../modal/wallet-selector-modal";
import { WalletRow } from "./wallet-row";

interface WalletTabContentProps {
  wallets: Array<AdapterNotDetectedWallet | AdapterWallet>;
  installableWallets: AdapterNotDetectedWallet[];
  tab: SupportedNetworkId;
  onConnect?: (tab: SupportedNetworkId) => void;
  header?: React.ReactNode;
  /** Rendered between detected wallets and installable (uninstalled) wallets */
  afterWallets?: React.ReactNode;
  footer?: React.ReactNode;
}

export function WalletTabContent({
  wallets,
  installableWallets,
  tab,
  onConnect,
  header,
  afterWallets,
  footer,
}: WalletTabContentProps) {
  const handleRowConnect = useCallback(() => onConnect?.(tab), [onConnect, tab]);

  return (
    <div className={stack({ gap: "8" })}>
      {header}
      {wallets.map((wallet) => (
        <WalletRow key={wallet.name} wallet={wallet} onConnect={handleRowConnect} />
      ))}
      {afterWallets}
      {wallets.length && !!installableWallets.length ? (
        <div className={stack({ gap: "8" })}>
          {installableWallets.map((wallet) => (
            <WalletRow key={wallet.name} wallet={wallet} onConnect={handleRowConnect} />
          ))}
        </div>
      ) : (
        installableWallets.map((wallet) => (
          <WalletRow key={wallet.name} wallet={wallet} onConnect={handleRowConnect} />
        ))
      )}
      {footer}
    </div>
  );
}
